import React from 'react'
import { usePlace } from 'commons/usePlace'
import * as R from 'ramda'
import { FormattedMessage } from 'react-intl'
import { WarningDangerPanel } from './panel/WarningPanel'
import { useAppName } from 'commons/usePartner'

export default ({ isThenDescriptionValue }) => {
  const place = usePlace()
  const appName = useAppName()

  const has = R.complement(R.propSatisfies(R.isNil))

  const moreThan100 = R.propSatisfies(
    R.compose(R.gte(R.__, 100), R.length),
    'description',
  )

  const isShowNotComplete = R.compose(
    R.not,
    R.allPass([has('logo'), has('description'), moreThan100]),
    R.prop('info'),
  )(place)

  const showPopupInChange = () => {
    return (
      <div>
        <WarningDangerPanel>
          <FormattedMessage
            id="notificationTimeline.placeProfile.not.visible"
            values={{ appName }}
          />
        </WarningDangerPanel>
      </div>
    )
  }
  const isShowNotCompleteHandler = () => {
    return (
      <div>
        {isShowNotComplete && (
          <WarningDangerPanel>
            <FormattedMessage id="notificationTimeline.placeProfile.not.visible" />
          </WarningDangerPanel>
        )}
      </div>
    )
  }
  const showPopup = () => {
    return isThenDescriptionValue
      ? showPopupInChange()
      : isShowNotCompleteHandler()
  }
  return showPopup()
}
